// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"FBHDJVee4A4Pm1G0EwuJ","spaceLeft":"_2BK4UYbaZIaer_-KP_9PYG","spaceBoth":"_2ZrLO3_QyNvdJX_HxDsvkA","spaceRight":"_3TUtcihTazPOzgHAXjh-nb","OasisMarket":"X2Mvbt9j3wFfO8Qsgra9u","OasisMarketAddress":"_38WH8tXhWN22d8QhJRCr43","label":"_2YqcZVh4-J1XLj-qDPcdeN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisMarket.scss
// module id = 1042
// module chunks = 0